import React, { useState } from "react";
import { Button, Spinner, Form, InputGroup, Card } from "react-bootstrap";
import PaymentService from "./PaymentService";
const ConnectStripe = () => {
    const [loading, setLoading] = useState(false);
    const [stripeAccount, setStripeAccount] = useState();
    const handleConnectNewStripeAccount = () => {
        setLoading(true);
        PaymentService.connectStripe().then(data => {
            window.location.href = data.url;
        }).catch(() => {
            setLoading(false);
        });
    };
    const handleConnectAccount = () => {
        if(!stripeAccount){
            return;
        }
        PaymentService.connectExistentStripeAccount(stripeAccount).then(data=>{
            window.location.reload();
        }).catch((error)=>console.error)
        window.location.reload();
    };
    const handleStripeAccount = event => {
        const { name, value } = event.target;
        setStripeAccount(value);
    };
    return (
        <>
            <Card>
                <Card.Header>
                    <h3>Connect with Stripe</h3>
                </Card.Header>
                <Card.Body>

                    <strong>Do you already have a Stripe Account?</strong>
                    <InputGroup size="sm" style={{ maxWidth: '50%' }} className="mt-2">
                        <Form.Control
                            name="stripeAccount"
                            type="text"
                            placeholder="Your account id (acct_1TwOHE2QnKj2ps7y)"
                            onChange={handleStripeAccount}
                        />
                        <Button id="activateButton" onClick={handleConnectAccount} className="btn btn-primary">Connect your account</Button>
                    </InputGroup>

                    <br /><br />
                    <strong>if you don't have a Stripe account yet.</strong>
                    <Button onClick={handleConnectNewStripeAccount} variant="success" className='btn btn-sm mx-2' disabled={loading}>
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                Connecting...
                            </>
                        ) : (
                            "Create New"
                        )}
                    </Button>
                </Card.Body>
            </Card>
        </>
    )
};
export default ConnectStripe;
